import request from "@/utils/request";

export function getAllTarh(ezam) {
  return request({
    url: "/jazb/Tarh?ezam=" + ezam,
    method: "post",
  });
}

export function saveJazb(data) {
  return request({
    url: "/jazb/Save",
    method: "post",
    data: data,
  });
}

export function getJazbHistory() {
  return request({
    url: "/jazb/GetHistory",
    method: "post",
  });
}

export function CancelRequest(id) {
  return request({
    url: "/jazb/Cancel",
    method: "post",
    data: {
      Fserial: id
    }
  });
}
